import { IStatus } from '@/shared/model/status.model';
import { IChanceWeight } from '@/shared/model/chanceWeight.model';
import { CustomerInterested } from '@/shared/model/enumerations/customer-interested.enum';
import { ISalesArea } from '@/shared/model/sales-area.model';

export interface ICustomerListEdit {
  id?: number | null;
  contactDate?: Date | null;
  insideSales?: string | null;
  salesArea?: ISalesArea | null;
  salesFunnel?: string | null;
  valueFromCustomer?: number | null;
  calculationValue?: number | null;
  status?: IStatus | null;
  infoPacket?: Date | null;
  resend?: string | null;
  customerInterest?: CustomerInterested | null;
  modelIdent?: string | null;
  consultDate?: Date | null;
  appraiseDate?: Date | null;
  brokerDate?: Date | null;
  unbindingOfferDate?: Date | null;
  bindingOfferDate?: Date | null;
  contractDraftDate?: Date | null;
  contractDate?: Date | null;
  estimatedPropertyValue?: number | null;
  provision?: number | null;
  chance?: IChanceWeight | null;
  estimate?: Date | null;
  informationEventDate?: Date | null;
  informationEventPlace?: string | null;
  informationEvent?: number | null;
  externalMarketers?: string[] | null;
}

export class CustomerListEdit implements ICustomerListEdit {
  constructor(
    public id?: number | null,
    public contactDate?: Date | null,
    public insideSales?: string | null,
    public salesArea?: ISalesArea | null,
    public salesFunnel?: string | null,
    public valueFromCustomer?: number | null,
    public calculationValue?: number | null,
    public status?: IStatus | null,
    public infoPacket?: Date | null,
    public resend?: string | null,
    public customerInterest?: CustomerInterested | null,
    public modelIdent?: string | null,
    public consultDate?: Date | null,
    public unbindingOfferDate?: Date | null,
    public appraiseDate?: Date | null,
    public brokerDate?: Date | null,
    public bindingOfferDate?: Date | null,
    public contractDraftDate?: Date | null,
    public contractDate?: Date | null,
    public estimatedPropertyValue?: number | null,
    public provision?: number | null,
    public chance?: IChanceWeight | null,
    public estimate?: Date | null,
    public informationEventDate?: Date | null,
    public informationEventPlace?: string | null,
    public informationEvent?: number | null,
    public externalMarketers?: string[] | null
  ) {}
}
